import React, { useState } from "react";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { hitUpdateBidProfessionalApi } from "../../../Redux/Professional/BidUpdateProfessionalSlice";
import { hitGetJobPaymentHistoryProfessionalApi } from "../../../Redux/Professional/GetJobPaymentHistoryProfessionalSlice";
import { hitGetBidDetailsProfessionalApi } from "../../../Redux/Professional/BidDetailsProfessionalSlice";
import { hitSavePaymentRequestJobAPi } from "../../../Redux/Professional/SavePaymentRequestJobSlice";
import { showToast } from "../../../Helper/Toast";
import { Briefcase, DollarSign, ChevronRight } from "lucide-react";
import Loader from "../../Loader/Loader"; // adjust the path
import { useGlobalState } from "../../../Providers/GlobalStateProvider";

const Payment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setGlobalLoading } = useGlobalState();
  //   const [showSuccessModal, setShowSuccessModal] = useState(false);
  //   const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  //   const [showMarkCompleteModal, setShowMarkCompleteModal] = useState(false);
  //   const [showFeedback, setShowFeedback] = useState(false);
  //   const [showJobDetails, setShowJobDetails] = useState(false);
  //   const [paymentCollected, setPaymentCollected] = useState(false);

  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [paymentType, setPaymentType] = useState("deposit");
  const [clientMessage, setClientMessage] = useState("");
  const [jobData, setJobData] = useState(null);
  const [currentBalance, setCurrentBalance] = useState(0);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [showPaymentHistory, setShowPaymentHistory] = useState(false);
  const [showPaymentRequestDetails, setShowPaymentRequestDetails] =
    useState(true);
  const [paymentHistoryData, setPaymentHistoryData] = useState([]);
  const [showExternalPaymentForm, setShowExternalPaymentForm] = useState(false);
  const [showStripePaymentModel, setShowStripePaymentModel] = useState(false);

  const [externalPaymentData, setExternalPaymentData] = useState({
    paymentMethod: "cash",
    paymentType: "deposit",
    paymentAmount: "",
    paymentDate: "",
  });

  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  const fetchPaymentHistory = () => {
    setLoading(true);
    setGlobalLoading(true);
    const pathParts = window.location.pathname.split("/");
    const jobId = pathParts[pathParts.length - 1];
    const payload = {
      jobId: jobId,
    };

    dispatch(hitGetJobPaymentHistoryProfessionalApi(payload)).then((res) => {
      setLoading(false);
      setGlobalLoading(false);
      if (res.payload && res.payload.status === true) {
        setPaymentHistoryData(res.payload.data?.paymentHistory || []);
        setJobData(res.payload.data?.jobInfo || null);
        setCurrentBalance(
          res.payload.data?.jobInfo?.pendingAmountForRequest ?? 0
        );
      }
    });
  };

  const handleSwitchToggle = () => {
    setShowExternalPaymentForm(!showExternalPaymentForm);
  };

  //   const handlePaymentToggle = (e) => {
  //     e.stopPropagation();
  //     setNewPaymentExpternalShow(true);
  //   };

  const saveStripePayment = () => {
    if (paymentAmount === "") {
      showToast("Please enter payment amount", "error");
      return;
    }
    let objRequest = {
      bidId: jobData ? jobData.assignedBidId : "",
      jobId: jobData ? jobData._id : "",
      type: parseInt(paymentType),
      amount: paymentAmount.toString(),
      clientMessage: clientMessage || "",
      viaStripe: 1,
    };
    setLoading(true);
    setGlobalLoading(true);
    dispatch(hitSavePaymentRequestJobAPi(objRequest)).then((res) => {
      setLoading(false);
      setGlobalLoading(false);
      if (res.payload && res.payload.status === true) {
        showToast("Payment request saved successfully", "success");
        fetchPaymentHistory();
        setShowStripePaymentModel(false);
        setPaymentAmount("");
        setPaymentDate("");
      }
    });
  };

  const savePayment = () => {
    if (
      paymentAmount === "" ||
      paymentDate === "" ||
      paymentMethod === "" ||
      paymentType === ""
    ) {
      showToast("Please fill all fields", "error");
      return;
    }
    if (parseFloat(paymentAmount) > parseFloat(currentBalance)) {
      showToast(
        "Payment amount cannot be greater than current balance",
        "error"
      );
      return;
    }
    let objRequest = {
      bidId: jobData ? jobData.assignedBidId : "",
      jobId: jobData ? jobData._id : "",
      mode: parseInt(paymentMethod),
      type: parseInt(paymentType),
      amount: paymentAmount.toString(),
      date: new Date(paymentDate),
    };
    setLoading(true);
    setGlobalLoading(true);
    dispatch(hitSavePaymentRequestJobAPi(objRequest)).then((res) => {
      setLoading(false);
      setGlobalLoading(false);
      if (res.payload && res.payload.status === true) {
        showToast("Payment request saved successfully", "success");
        fetchPaymentHistory();
        setShowExternalPaymentForm(false);
        setPaymentAmount("");
        setPaymentDate("");
      }
    });
  };

  const [isPaymentEnabled, setIsPaymentEnabled] = useState(false);
  const [activeTab1, setActiveTab1] = useState("request");

  if (loading) {
    setGlobalLoading(true);
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }
  return (
    <>
      <div className="pro-app-page">
        <div className="custom_container payment-cards_top1">
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#b83c3c",
            marginBottom: "30px",
            marginTop: "0",
          }}
        >
          Payments
        </h1>

        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
            marginBottom: "30px",
          }}
        >
          <button
            onClick={() => {
              setActiveTab1("request");
              setShowPaymentHistory(false);
              setShowPaymentRequestDetails(true);
            }}
            style={{
              padding: "12px 28px",
              fontSize: "15px",
              fontWeight: "600",
              backgroundColor: activeTab1 === "request" ? "#b83c3c" : "#f3f4f6",
              color: activeTab1 === "request" ? "white" : "#374151",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              outline: "none",
            }}
          >
            Request Payment
          </button>

          <button
            onClick={() => {
              setActiveTab1("history");
              setShowPaymentHistory(true);
              setShowPaymentRequestDetails(false);
            }}
            style={{
              padding: "12px 28px",
              fontSize: "15px",
              fontWeight: "600",
              backgroundColor: activeTab1 === "history" ? "#b83c3c" : "#f3f4f6",
              color: activeTab1 === "history" ? "white" : "#374151",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              outline: "none",
            }}
          >
            Payment History
          </button>
        </div>
        {showPaymentRequestDetails && (
          <>
            <div className="payment-title-card">
              <h4>Request Payment</h4>
            </div>

            <div className="external-payment-form mt-0">
              <div>
                {/* Job Card */}
                <div className="payment-card-1">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Briefcase size={20} color="#666" />
                    </div>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                      }}
                    >
                      Job {jobData ? jobData.jobId : ""}
                    </span>
                  </div>
                  {/* <ChevronRight size={20} color="#999" /> */}
                </div>

                {/* Payment Toggle Card */}
                <div className="payment-card-1 mb-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <DollarSign size={20} color="#666" />
                    </div>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#333",
                      }}
                    >
                      Payment Collected Externally
                    </span>
                  </div>

                  {/* Toggle Switch */}
                  <div
                    onClick={() =>
                      setShowExternalPaymentForm(!showExternalPaymentForm)
                    }
                    style={{
                      width: "60px",
                      height: "30px",
                      background: showExternalPaymentForm
                        ? "linear-gradient(90deg, #CC4645 0%, #9A1D1C 100%)"
                        : "#ccc",
                      borderRadius: "15px",
                      position: "relative",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        width: "26px",
                        height: "26px",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "2px",
                        left: showExternalPaymentForm ? "32px" : "2px",
                        transition: "left 0.3s ease",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      }}
                    />
                  </div>
                </div>
              </div>

              {showExternalPaymentForm && (
                <div className="external-payment-form">
                  <h3 className="form-title">
                    Current balance (USD): ${currentBalance}
                  </h3>

                  <h3 className="form-title">
                    How was the payment handled externally?
                  </h3>

                  {/* Payment Method */}
                  <div className="form-group">
                    <label className="form-label">Payment Mode</label>
                    <div className="radio-group">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="1"
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />

                        <span>Cash</span>
                      </label>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="2"
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <span>Check</span>
                      </label>

                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="3"
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <span>Financing</span>
                      </label>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentMethod"
                          value="5"
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <span>Other</span>
                      </label>
                    </div>
                  </div>

                  {/* Payment Type */}
                  <div className="form-group">
                    <label className="form-label">Payment Type</label>
                    <div className="radio-group">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentType"
                          value="1"
                          onChange={(e) => setPaymentType(e.target.value)}
                        />
                        <span>Deposit</span>
                      </label>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentType"
                          value="2"
                          onChange={(e) => setPaymentType(e.target.value)}
                        />
                        <span>Final</span>
                      </label>

                      {/* <label className="radio-label">
                    <input
                      type="radio"
                      name="Refund"
                      value="Refund" />
                    <span>Refund</span>
                  </label> */}

                      <label className="radio-label">
                        <input
                          type="radio"
                          name="paymentType"
                          value="3"
                          onChange={(e) => setPaymentType(e.target.value)}
                        />
                        <span>Other</span>
                      </label>
                    </div>
                  </div>

                  {/* Payment Amount */}
                  <div className="form-group">
                    <label className="form-label">Payment Amount</label>
                    <input
                      type="number"
                      className="form-input"
                      placeholder="Enter Amount"
                      onChange={(e) => setPaymentAmount(e.target.value)}
                    />
                  </div>

                  {/* Payment Date */}
                  <div className="form-group">
                    <label className="form-label">Payment Date</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        className="form-input date-input pe-2"
                        placeholder="Enter Date"
                        onChange={(e) => setPaymentDate(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    className="submit-external-payment-btn"
                    onClick={() => {
                      savePayment();
                    }}
                  >
                    Submit
                  </button>
                </div>
              )}

              {!showExternalPaymentForm && (
                <button
                  className="submit-external-payment-btn"
                  onClick={() => {
                    setShowStripePaymentModel(true);
                  }}
                >
                  Request Payment
                </button>
              )}
            </div>
          </>
        )}

        <div className="profile-cardss payment-cards_top">
          {showPaymentHistory && (
            <div className="payment-history-section">
              <h3 className="payment-history-title">Payment History</h3>
              <div className="payment-history-table">
                <div className="payment-history-header">
                  <span>Type/Mode</span>
                  <span>Date</span>
                  <span>Status</span>
                  <span>Amount</span>
                </div>
                {paymentHistoryData && paymentHistoryData.length > 0 ? (
                  paymentHistoryData.map((payment, index) => (
                    <div
                      //  key={index}
                      className="payment-history-row"
                    >
                      <div className="payment-type">
                        <span className="type-label">
                          {payment.type === 1
                            ? "Deposit"
                            : payment.type === 2
                              ? "Final"
                              : "Other"}{" "}
                          ({" "}
                          {payment.mode === 1
                            ? "Cash"
                            : payment.mode === 2
                              ? "Check"
                              : payment.mode === 3
                                ? "Finance"
                                : "Other"}
                          ) ({payment.viaStripe === 1 ? "Stripe" : "External"})
                        </span>
                        {/* <span className="type-sublabel">Payment Sent</span> */}
                      </div>

                      <span className="payment-date">{payment.date}</span>
                      <div className="payment-amount-wrapper">
                        <span
                          className="payment-status"
                          style={{
                            color:
                              payment.status === 1
                                ? "#0a8800"
                                : payment.status === 2
                                  ? "#c80000"
                                  : "#b37a00",
                            backgroundColor:
                              payment.status === 1
                                ? "#e5f9e7"
                                : payment.status === 2
                                  ? "#ffe5e5"
                                  : "#fff7e0",
                            fontWeight: 600,
                            padding: "4px 8px",
                            borderRadius: "4px",
                          }}
                        >
                          {payment.status === 1
                            ? "Completed"
                            : payment.status === 2
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </div>


                      <span className="payment-amount">${payment.amount}</span>
                    </div>
                  ))
                ) : (
                  <div className="no-payments">
                    No payment history available.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {showStripePaymentModel && (
          <div className="modal-overlay-payment">
            <div className="payment-modal">
              {/* Header */}
              <div className="payment-modal-header">
                <h2 className="payment-modal-title">Payments</h2>
                <button
                  className="close-btn"
                  onClick={() => setShowStripePaymentModel(false)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M18 6L6 18M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Content */}
              <div className="payment-modal-content">
                {/* Current Balance */}
                <div className="balance-card">
                  <div className="balance-label">Current Balance (USD):</div>
                  <div className="balance-amount">${currentBalance}</div>
                </div>

                {/* Payment Amount */}
                <div className="form-group">
                  <label className="form-label">Payment Amount</label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter Amount"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                  />
                </div>

                {/* Client Message */}
                <div className="form-group">
                  <label className="form-label">
                    Client Message (optional)
                  </label>
                  <textarea
                    className="form-textarea"
                    placeholder="Enter message"
                    rows="4"
                    value={clientMessage}
                    onChange={(e) => setClientMessage(e.target.value)}
                  >
                    Thank you for your business!
                  </textarea>
                </div>

                {/* Payment Type */}
                <div className="form-group">
                  <label className="form-label">Payment Type</label>
                  <div className="radio-group">
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="paymentType"
                        onChange={() => setPaymentType(1)}
                      />
                      <span className="radio-label">Deposit</span>
                    </label>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="paymentType"
                        onChange={() => setPaymentType(2)}
                      />
                      <span className="radio-label">Final</span>
                    </label>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="paymentType"
                        onChange={() => setPaymentType(3)}
                      />
                      <span className="radio-label">Other</span>
                    </label>
                  </div>
                </div>

                {/* Payment Options */}
                {/* <div className="form-group">
        <label className="form-label">Payment options for client</label>
        <div className="payment-option-card" style={{ cursor: "default" }}>
          <span className="stripe-text">stripe</span>
          <div className="toggle-switch-payment active">
            <div className="toggle-track-payment">
              <div className="toggle-thumb-payment"></div>
            </div>
          </div>
        </div>
      </div> */}

                {/* Submit Button */}
                <button
                  className="submit-payment-btn"
                  onClick={() => saveStripePayment()}
                >
                  Request Payment
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      </div>
    </>
  );
};

export default Payment;
